import React from "react";

interface CategoryTreeSkeletonProps {
  /** Number of placeholder rows to render. */
  rows?: number;
}

// Indentation + width patterns to mimic a nested category tree while loading.
const INDENTS = [0, 0, 16, 16, 0, 16, 32, 0, 16, 0, 16, 16];
const WIDTHS = [
  "70%",
  "55%",
  "60%",
  "45%",
  "68%",
  "50%",
  "40%",
  "72%",
  "48%",
  "58%",
  "44%",
  "62%",
];

/**
 * Loading placeholder for the document category tree. Row height matches the
 * arborist tree's `rowHeight` so there is no layout shift once data loads.
 */
const CategoryTreeSkeleton: React.FC<CategoryTreeSkeletonProps> = ({
  rows = 10,
}) => (
  <div className="animate-pulse" aria-hidden="true">
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={index}
        className="flex items-center"
        style={{ height: 30, paddingLeft: INDENTS[index % INDENTS.length] }}
      >
        <div className="h-4 w-4 rounded bg-gray-200 mr-2 flex-shrink-0" />
        <div
          className="h-3 rounded bg-gray-300"
          style={{ width: WIDTHS[index % WIDTHS.length] }}
        />
      </div>
    ))}
  </div>
);

export default CategoryTreeSkeleton;
